import { Container } from "unstated";
import { store } from "./browserStore";

const STORAGE_KEY = "auth";

class AuthContainer extends Container {
  constructor(props = {}) {
    super();
    const token = store.get(STORAGE_KEY);
    this.state = { token };
  }
  setAuth = (token) => {
    store.set(STORAGE_KEY, token);
    this.setState({ token });
  };
  delAuth = () => {
    store.remove(STORAGE_KEY);
    this.setState({ token: null });
  };
  getAuth = () => this.state.token;
  hasAuth = () => !!this.state.token;
}

export default AuthContainer;
